import React, { Component } from "react";
import { render } from 'react-dom'

import { Dropdown, Icon, Input, Menu, Button, Image, Header, Segment, Grid, Divider, Label } from 'semantic-ui-react'
import _ from "lodash"

import "./StoryLogo.css";

import deepsingLogo from "../images/deepsing.png"
import deepsingLogoWhite from "../images/deepsing_white.png"

import deepsingLogoText from "../images/deepsing_text.png"
import PlayerContext from "../../../../playerContext";

class StoryLogo extends Component {
    state = {
    }

    static contextType = PlayerContext

    componentDidMount = () => {


        setInterval(() => {
            const playerStatus = this.context
            !playerStatus.paused && this.setState((state) => ({
                size: Math.random() * (1.1 - 0.7) + 0.7
            }));
        }, 200)
    }

    timeToMetadata = (time) => {
        const playerStatus = this.context
        return _.head(_.filter(playerStatus.metadata, (instance) => {
            return time >= instance.time && time <= instance.time + 5
        }))
    }

    render() {
        const playerStatus = this.context

        const currentMeta = playerStatus.metadata ? this.timeToMetadata(playerStatus.currentSeconds) : null

        return (
            <div style={{ "height": "130px;" }}>
                <Image
                    style={{
                        // "maxHeight":this.state.size
                        "WebkitTransform": `scale(${this.state.size})`,
                        "msTransform": `scale(${this.state.size})`,
                        "transform": `scale(${this.state.size})`,
                        "transition": "transform 0.2s ease-in-out"
                    }}

                    src={deepsingLogoWhite}
                    className="deepsingLogo"
                    alt="deepsing" centered />
            </div>
        )
    }
}

export default StoryLogo